import { useCallback, useEffect, useRef } from "react";

/**
 * Retains the previous value for which isGateOpen returns true.
 */
export function useGatedValue<T>(value: T, isGateOpen: (currentValue: T, previousValue: T) => boolean): T {
    // Value is always initialized.
    const ref = useRef(value);

    useEffect(
        () => {
            if (isGateOpen(value, ref.current)) {
                ref.current = value;
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [value],
    );

    return isGateOpen(value, ref.current) ? value : ref.current;
}

/**
 * Retains the previous value for which isGateOpen returns false.
 */
export function useInverseGatedValue<T>(value: T, isGateClosed: (currentValue: T, previousValue: T) => boolean): T {
    const isGateOpen = useCallback(
        (currentValue: T, previousValue: T): boolean => !isGateClosed(currentValue, previousValue),
        [isGateClosed],
    );
    return useGatedValue(value, isGateOpen);
}
